import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于奇妙漫画网，你可能想了解的一切</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left group"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === idx
                    ? 'bg-primary-500 text-background-50 rotate-180'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}